module.exports = __webpack_public_path__ + "static/media/ny.02d1271a.hdr";